import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  createStyles,
  makeStyles,
  Divider,
  Theme,
  Typography,
  Button,
  Box,
  Grid,
  TextField,
} from '@material-ui/core';
import PaperColumn from '../components/PaperColumn';
import { useMount } from '../hooks/useMount';
import { getAppInsights } from '../TelemetryService';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    divider: {
      margin: theme.spacing(3, 0),
    },
    centreText: {
      textAlign: 'center',
      marginTop: theme.spacing(2),
    },
    button: {
      color: '#FFF',
      minWidth: '200px',
      margin: '0 auto',
      display: 'flex',
      marginTop: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    [theme.breakpoints.down('xs')]: {
      box: {
        flexDirection: 'column',
        '& > *': {
          justifyContent: 'center',
        },
      },
    },
  })
);

const FindInvoice: React.FunctionComponent = () => {
  const classes = useStyles();
  const history = useHistory();
  const [invoiceNumber, setInvoiceNumber] = useState({
    value: '',
    error: false,
    errorMessage: '',
  });
  const [authCode, setAuthCode] = useState({
    value: '',
    error: false,
    errorMessage: '',
  });

  useMount(() => {
    getAppInsights().trackEvent({
      name: 'Find Invoice page: ',
    });
  });

  const handleBlur = (event: any) => {
    const { value, name } = event.target;

    validate(value, name);
  };

  const validate = (value: string, name: string) => {
    switch (name) {
      case 'Invoice Number':
        setInvoiceNumber({
          value: value,
          error: !value.length,
          errorMessage: !value.length ? `${name} cannot be empty` : '',
        });
        break;
      case 'Authorisation Code':
        setAuthCode({
          value: value,
          error: !value.length,
          errorMessage: !value.length ? `${name} cannot be empty` : '',
        });
        break;
      default:
        break;
    }
  };

  const handleFindInvoice = async () => {
    if (!!invoiceNumber.value.length && !!authCode.value.length) {
      const id = new URLSearchParams(window.location.search).get('id');

      const url = !id 
        ? `/invoice/${invoiceNumber.value}/${authCode.value}` 
        : `/invoice/${invoiceNumber.value}/${authCode.value}?id=${id}`;

      history.push(url);
    }

    validate(invoiceNumber.value, 'Invoice Number');
    validate(authCode.value, 'Authorisation Code');
  };

  return (
    <div className={classes.root}>
      <PaperColumn>
        <Typography variant="h5" gutterBottom className={classes.centreText}>
          Find Invoice
          <div>
            <Typography variant="subtitle2" className={classes.header}>
              To check the status of an invoice and then pay it online please enter your invoice
              number and authorisation code below.
            </Typography>
          </div>
          <Divider variant="middle" className={classes.divider} />
          <Box display="flex" p={1} className={classes.box}>
            <Grid container justify="center">
              <Grid item xs={6} sm={5} md={3}>
                <TextField
                  name="Invoice Number"
                  label="Invoice Number"
                  variant="outlined"
                  required
                  defaultValue={invoiceNumber.value}
                  onBlur={handleBlur}
                  error={!!invoiceNumber.error}
                  helperText={invoiceNumber.errorMessage}
                />
              </Grid>
              <Grid item xs={6} sm={5} md={3}>
                <TextField
                  name="Authorisation Code"
                  label="Authorisation Code"
                  variant="outlined"
                  required
                  defaultValue={authCode.value}
                  onBlur={handleBlur}
                  error={!!authCode.error}
                  helperText={authCode.errorMessage}
                />
              </Grid>
            </Grid>
          </Box>
          <Button
            size="medium"
            variant="contained"
            color="secondary"
            type="submit"
            className={classes.button}
            onClick={handleFindInvoice}
          >
            Find Invoice
          </Button>
        </Typography>
      </PaperColumn>
    </div>
  );
};

export default FindInvoice;
